import { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { API_BASE } from '@/utils/api';

const MSG = {
  not_found: ['text-destructive', 'Este CUIT no figura en el padrón de AFIP'],
  inactive: ['text-destructive', 'Este CUIT no está activo en AFIP'],
  unavailable: ['text-muted-foreground', 'AFIP no responde ahora: podés registrarte y lo verificamos después'],
};

// Consulta el padrón cuando el CUIT tiene 11 dígitos y muestra la razón social
export const CuitLookup = ({ cuit }) => {
  const digits = (cuit || '').replace(/\D/g, '');
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setRes(null);
    if (digits.length !== 11) return undefined;
    let alive = true;
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await axios.post(`${API_BASE}/public/cuit-lookup`, { cuit: digits });
        if (alive) setRes(data);
      } catch (e) {
        if (alive) setRes({ status: 'error', detail: e.response?.data?.detail });
      } finally {
        if (alive) setLoading(false);
      }
    }, 400);
    return () => { alive = false; clearTimeout(t); };
  }, [digits]);
  if (loading) return <p className="text-xs text-muted-foreground flex items-center gap-1" data-testid="cuit-lookup-loading"><Loader2 className="w-3 h-3 animate-spin" />Consultando AFIP…</p>;
  if (!res) return null;
  if (res.status === 'active') return <p className="text-xs font-semibold text-emerald-600" data-testid="cuit-razon-social">{res.razon_social || 'CUIT activo'}</p>;
  const [cls, text] = MSG[res.status] || ['text-destructive', typeof res.detail === 'string' ? res.detail : 'No pudimos validar el CUIT'];
  return <p className={`text-xs ${cls}`} data-testid="cuit-lookup-status">{text}</p>;
};
